import React, {ChangeEvent} from 'react';

import isEmpty from 'lodash.isempty';
import {EventReviewFeedback} from 'src/modules/ai';
import {HeaderFields} from 'src/modules/event-create/constants';
import {TRIGGER_INFO} from 'src/modules/event-create/event-create-hovers';
import {HeaderBlock} from 'src/modules/event-create/typedefs';
import {
    MAX_LENGTH_TRIGGER,
    eventTriggerValidation,
} from 'src/modules/event-create/validations/event-trigger-validation';
import {EventBasicInfo} from 'src/openapi/models/EventBasicInfo';

import {Dropdown} from '@pb/kit-component-dropdown-v2';
import {Group, Item} from '@pb/kit-component-group';
import {InfoIconButton} from '@pb/kit-component-icon-button';
import {Loading, Types} from '@pb/kit-component-loading';
import {Textarea} from '@pb/kit-component-textarea-v2';

type Props = {
    headerValues: HeaderBlock,
    validationHighLight: boolean,
    changeRequestId: number | null,
    onChangeField: (value: string, name?: string) => void,
    onTriggerBlur: (event: React.FocusEvent<HTMLTextAreaElement>) => void,
    eventsInfo: EventBasicInfo[],
};

export const EventTrigger = (props: Props) => {
    const {
        headerValues,
        eventsInfo,
        changeRequestId,
        onChangeField,
        onTriggerBlur,
    } = props;

    const hasValidationError =
        Boolean(props.validationHighLight && eventTriggerValidation(headerValues.trigger).length);

    const onChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        onChangeField(event.currentTarget.value, HeaderFields.trigger);
    };

    return (
        <Group direction="v" gap="xxs" justify="space-between">
            <Group gap="xs" alignItems="center">
                <strong>Trigger:</strong>
                <Dropdown
                    hoverEnabled={true}
                    clickEnabled={false}
                    maxWidth={500}
                    anchor={({anchorRef, getAnchorProps}) => (
                        <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                    )}>
                    {TRIGGER_INFO}
                </Dropdown>
                <EventReviewFeedback
                    changeRequestId={changeRequestId}
                    fieldName={HeaderFields.trigger}
                />
            </Group>
            <Group alignItems="center">
                <Item style={{width: '100%'}}>
                    <Textarea
                        resizable={false}
                        placeholder="Trigger Description"
                        name={HeaderFields.trigger}
                        style={{height: 75}}
                        color={hasValidationError ? 'ERROR' : 'DEFAULT'}
                        maxLength={MAX_LENGTH_TRIGGER}
                        value={headerValues.trigger}
                        onBlur={onTriggerBlur}
                        onChange={onChange}
                    />
                </Item>
                <Item style={{width: '1rem'}}>
                    {isEmpty(eventsInfo) && (
                        <Loading fast={true} type={Types.ICON}/>
                    )}
                </Item>
            </Group>
        </Group>
    );
};
